import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { message } from "antd";
// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN, GET_IP } from "./actionTypes";
import {
  apiError,
  loginSuccess,
  loginPermission,
  logoutUserSuccess,
  getIpSuccess,
  getIpError,
  loginUserInfo,
} from "./actions";

//Include Both Helper File with needed methods
import {
  listRouter,
  capitalizeFirstLetter,
  setToken,
  setUserIdStorage,
} from "../../../helpers/common";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postSocialLogin } from "../../../helpers/fakebackend_helper";
import i18next from "i18next";
import { postLogin, getIpFp, getUserInfoById } from "../../../helpers/helper";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const fireBaseBackend = getFirebaseBackend();

function* getFingerprint() {
  const fp = yield FingerprintJS.load();
  const { visitorId } = yield fp.get();

  return visitorId;
}

const checkRoleUser = async (user) => {
  try {
    const role = user?.role;
    const { actions, roleName } = role;
    const dataResultParam = [];
    if (roleName === "SuperAdmin") {
      listRouter.forEach((param) => {
        dataResultParam.push({
          key: param.key,
          value: true,
          url: param.url,
        });
      });
    } else {
      let listAllAction = user?.allActions;
      const listAllActionByRole = [];
      listAllAction?.forEach((item) => {
        const checkAction = actions?.includes(item._id);
        if (checkAction) {
          listAllActionByRole.push({
            _id: item._id,
            actionName: item.actionName,
          });
        }
      });

      listRouter.forEach((param) => {
        let checkVisible = false;
        let strPaging = "";
        switch (param.url) {
          case "company-management":
            strPaging = `getCompanyManagementPage`;
            break;
          case "group-management":
            strPaging = `getGroupManagementPage`;
            break;
          case "history":
            strPaging = `getPagingHistories`;
            break;
          case "duplicate-ip":
            strPaging = `getSameIp`;
            break;
          case "duplicate-fp":
            strPaging = `getSameFp`;
            break;
          default:
            strPaging = `get${capitalizeFirstLetter(param.key)}ManagementPage`;
        }
        checkVisible = user?.actionGroups?.some((str) => str === param.key);
        const roleUserAction = listAllActionByRole?.some(
          (item) => item.actionName === strPaging
        );
        dataResultParam.push({
          key: param.key,
          value: checkVisible && roleUserAction,
          url: param.url,
        });
      });
    }
    return dataResultParam;
  } catch (error) {
    console.log(error);
  }
};

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_API_URL) {
      //sử dụng FingerprintJS để lấy fp

      const getIp = yield call(getIpFp);
      const fp = yield call(getFingerprint);

      const response = yield call(postLogin, {
        username: user.username,
        password: user.password,
        ip: getIp.data.ip,
        fp: fp,
      });
      try {
        if (response && response.status === 1) {
          if (response.data.user.role === null) {
            message.error(i18next.t("requiredPermission"));
          }
          if (
            response.data.user.role &&
            response.data.user.role.roleName === "user"
          ) {
            yield put(loginPermission());
            history.push("/no-access-permission");
          } else if (response.data.user) {
            setToken(response?.data?.token);
            setUserIdStorage(response?.data?.user?._id);
            const profileInfo = yield call(
              getUserInfoById,
              response.data.user._id
            );
            yield put(loginSuccess(response));
            if (profileInfo) {
              yield put(loginUserInfo(profileInfo));
              const roleUser = yield call(checkRoleUser, profileInfo);
              if (roleUser && roleUser.length > 0) {
                const path = roleUser.find(
                  (item) => item.key === "dashboard-employee"
                );
                sessionStorage.setItem("pathRoleUser", JSON.stringify(path));
                history.push(`/${path ? path.url : ""}`);
              }
            } else {
              history.push(`/`);
            }
          } else history.push("/no-access-permission");
        } else yield put(apiError(response));
      } catch (error) {
        history.push("/no-access-permission");
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getIp({}) {
  try {
    if (process.env.REACT_APP_API_URL) {
      const dataIp = yield call(getIpFp);
      if (dataIp) yield put(getIpSuccess(dataIp));
      else yield put(getIpError());
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    sessionStorage.clear();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history.push("/dashboard-employee");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(GET_IP, getIp);
}

export default authSaga;
